import { useTranslation } from 'react-i18next'
import { DailyCard } from '@/features/practice/components/DailyCard'
import { DueBanner } from '@/features/practice/components/DueBanner'
import { GameCatalog } from '@/features/practice/components/GameCatalog'

/**
 * `/jeux` — le point d'entrée des jeux de rappel actif (SPEC.md, Lot J) : le
 * jeu du jour en évidence, puis le catalogue des mécaniques réellement
 * jouables. Composé de deux widgets autonomes (`DailyCard`, `GameCatalog`),
 * chacun responsable de son propre chargement.
 */
export function GamesPage() {
  const { t } = useTranslation()

  return (
    <div className="min-h-full overflow-y-auto bg-surface px-container-px-mobile pb-20 pt-6 md:px-container-px-desktop md:pb-8">
      <div className="mx-auto flex max-w-3xl flex-col gap-8">
        <h1 className="font-display text-2xl font-bold text-on-surface">{t('practice.page_title')}</h1>

        <DueBanner />
        <DailyCard />
        <GameCatalog />
      </div>
    </div>
  )
}
